import React from 'react'

export interface BandProps {}

export const Band: React.FunctionComponent<BandProps> = ({ children }) => (
	<div className="band">
		<div className="band-in">{children}</div>
	</div>
)
